import React, { useContext } from "react";
import FixelDataContext from "../../../context/FixelDataContext";
import Notification from "./notificationSubComponents/Notification";
import PotentialGain from "./potentialGain/PotentialGainNotification";
import NoStatsNotification from "./noStats/NoStatsNotification";
import * as genNotifications from "./generateNotificationContent";
import * as shouldNotify from "./shouldDisplayNotification";
import { useHistory } from "react-router-dom";
import { StyledNotificationContainer } from "../dashboard.style";

const Notifications = () => {
  const history = useHistory();
  const { fullFixelData, setFullFixelData } = useContext(FixelDataContext);
  return (
    <StyledNotificationContainer>
      {shouldNotify.showTrialUnder7Days(fullFixelData) && (
        <Notification
          type="info"
          content={genNotifications.TrialNearEnd(fullFixelData.plan.trial_days_remaining)}
          CTA={() => {
            return history.push("/plans");
          }}
        />
      )}
      {shouldNotify.showTrialExpired(fullFixelData) && (
        <Notification
          type="warning"
          content={genNotifications.TrialOver()}
          CTA={() => {
            return history.push("/plans");
          }}
        />
      )}
      {shouldNotify.showNoActivePlan(fullFixelData) && (
        <Notification
          type="warning"
          content={genNotifications.NoPlan()}
          CTA={() => {
            history.push("/plans");
          }}
        />
      )}
      {shouldNotify.showIntegrationFailure(fullFixelData) && (
        <Notification
          type="warning"
          content={genNotifications.IntegrationFailure("Facebook")}
          CTA={() => {
            return history.push("/setup");
          }}
          onDismiss={() => {
            return localStorage.setItem("alertedFBIntegrationFailure", fullFixelData.code);
          }}
        />
      )}
      {shouldNotify.showFBIntegrationSuccessful(fullFixelData) && (
        <Notification
          type="success"
          content={genNotifications.IntegrationSuccess("Facebook")}
          CTA={() => {
            return localStorage.setItem("alertedFBIntegrationSuccessful", fullFixelData.code);
          }}
          onDismiss={() => {
            return localStorage.setItem("alertedFBIntegrationSuccessful", fullFixelData.code);
          }}
        />
      )}
      {shouldNotify.showSegmentActive(fullFixelData) && (
        <Notification
          type="success"
          content={genNotifications.SegmentActive("Facebook")}
          CTA={() => {
            return localStorage.setItem("alertedSegmentActive", fullFixelData.code);
          }}
          onDismiss={() => {
            return localStorage.setItem("alertedSegmentActive", fullFixelData.code);
          }}
        />
      )}
      {shouldNotify.showPaymentCompleted(fullFixelData) && (
        <Notification
          type="success"
          content={genNotifications.PaymentComplete(fullFixelData.newPlanDetails.name)}
          CTA={() => {
            return fullFixelData.newChargeID && localStorage.setItem("alertedChargeID", fullFixelData.newChargeID);
          }}
          onDismiss={() => {
            return fullFixelData.newChargeID && localStorage.setItem("alertedChargeID", fullFixelData.newChargeID);
          }}
        />
      )}
      {/* TODO how to check if new plan cheaper? */}
      {shouldNotify.showPlanDowngrade(fullFixelData) && (
        <Notification
          type="success"
          content={genNotifications.PlanDowngrade(fullFixelData.newPlanDetails.name)}
          CTA={() => {
            return fullFixelData.newChargeID && localStorage.setItem("alertedChargeID", fullFixelData.newChargeID);
          }}
          onDismiss={() => {
            return fullFixelData.newChargeID && localStorage.setItem("alertedChargeID", fullFixelData.newChargeID);
          }}
        />
      )}
      {shouldNotify.showAnalyzeProgressBar(fullFixelData) && <NoStatsNotification />}
      {shouldNotify.showPotentialRevenue(fullFixelData) && <PotentialGain />}
    </StyledNotificationContainer>
  );
};
export default Notifications;
